import { type HowItWorksStep as Step } from './content.ts';

type HowItWorksStepProps = {
    step: Step;
    /** On xl and up the image and copy swap sides from one step to the next. */
    imageFirst: boolean;
};

const HowItWorksStep = ({ step, imageFirst }: HowItWorksStepProps): JSX.Element => (
    <div className="flex flex-col xl:flex-row items-center justify-between">
        <div
            className={`w-full px-6 md:px-0 pt-10 xl:pt-0 xl:w-6/12 order-2 ${
                imageFirst ? 'xl:order-2' : 'xl:order-1'
            }`}
        >
            <h3 className="text-2xl text-center lg:text-left md:text-3xl xl:text-4xl font-bold">
                {step.title}
            </h3>
            <p className="mt-5 xl:mt-10 xl:text-lg">{step.body}</p>
        </div>
        <div
            className={`w-full xl:w-6/12 pt-10 xl:pt-0 order-1 ${
                imageFirst ? 'xl:order-1 lg:pr-28' : 'xl:order-2 lg:pl-28'
            }`}
        >
            <img
                className="m-auto w-full relative"
                src={step.image.src}
                alt={step.image.alt}
                width={step.image.width}
                height={step.image.height}
            />
        </div>
    </div>
);

export default HowItWorksStep;
